/**
 * Mouse action template names → normalized coordinates (0-1).
 * LLM picks template name, system resolves to pixel coordinates.
 */
// Coordinates calibrated for 1920x1080 layout:
// Title bar: 30px, Toolbar: 28px, Tab bar: 35px, Breadcrumb: 22px
// Left sidebar (ToolboxSidebar): 32px (w-8)
// Editor area: starts ~115px from top, left ~84px (sidebar + gutter)
// Solution Explorer: right ~240px wide
// Output panel: bottom ~180px high
// Status bar: 22px
const MOUSE_TEMPLATES = {
  'OFF_SCREEN_RIGHT': { x: 1.05, y: 0.5 },        // Off-screen right (entry/exit point)
  'CLICK_RUN_BUTTON': { x: 0.208, y: 0.041 },     // Toolbar ▶ HelloWorld button (~400px, ~44px)
  'CLICK_STOP_BUTTON': { x: 0.208, y: 0.041 },    // Same position as Run
  'CLICK_BUILD_MENU': { x: 0.131, y: 0.014 },     // Build menu in title bar (~252px, ~15px)
  'CLICK_BUILD_SOLUTION': { x: 0.152, y: 0.040 },// "Build Solution" item in dropdown (~292px, ~43px)
  'EDITOR_CENTER': { x: 0.44, y: 0.45 },           // Center of code editor area
  'SOLUTION_EXPLORER': { x: 0.94, y: 0.45 },       // Solution Explorer panel center
  'OUTPUT_PANEL': { x: 0.44, y: 0.90 },             // Output panel center
};

/**
 * Resolve mouse action template to pixel coordinates.
 * @param {string} action - Template name (e.g. "CLICK_RUN_BUTTON", "HOVER_LINE:5")
 * @param {{ width: number, height: number }} resolution
 * @returns {{ x: number, y: number }}
 */
export function resolveMouseTemplate(action, resolution = { width: 1920, height: 1080 }) {
  // Dynamic template: HOVER_LINE:{n}
  if (action.startsWith('HOVER_LINE:')) {
    const lineNum = parseInt(action.split(':')[1], 10);
    return {
      x: 0.35 * resolution.width,
      y: (0.18 + lineNum * 0.019) * resolution.height,
    };
  }

  const template = MOUSE_TEMPLATES[action];
  if (!template) {
    return { x: 0.5 * resolution.width, y: 0.5 * resolution.height };
  }
  return {
    x: template.x * resolution.width,
    y: template.y * resolution.height,
  };
}

export { MOUSE_TEMPLATES };
